<template>
    <b-container fluid class="mt-2 license-management-page">
        <b-row>
            <b-col cols="" class="px-1 px-sm-3" v-if="loadDetails">
                <div class="expiry-data d-flex justify-content-between align-items-center mb-4">
                    <h2 class="text-left mb-0">{{ $t('loadDetails.loadTitle', { number: loadDetails.load_number }) }}</h2>
                    <div class="d-flex align-items-center">
                        <div class="text-left select_arrow ">
                            <b-form-select class="f-14 custom-select-2" v-model="loadDetails.status" :options="statusOptions" />
                        </div>
                        <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 mt-0 ml-2">
                            <template slot="button-content">
                                <b-icon class="dots" icon="three-dots"></b-icon>
                            </template>
                            <b-dropdown-item-button @click="showHazmatFilePopup = true">
                                <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('loadDetails.delete') }}</p>
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </div>
                </div>
                <div class="pr-0 mb-3 d-block d-lg-flex w-100">
                    <div class="w-100">
                        <b-row>
                            <b-col md="3">
                                <div class="pt-3 px-3 bg-white table-custom-border rounded w-100 text-left">
                                    <h6 class="font-weight-bold">{{ loadDetails.driver_name }}</h6>
                                    <hr class="my-0" />
                                    <p class="f-14 mt-3">{{ loadDetails.load_number }}</p>
                                    <p class="f-14">{{ $t('loadDetails.referencePrefix') }} {{ loadDetails.reference_number }}</p>
                                    <hr class="my-0" />
                                    <p class="f-14 mt-3">{{ moment(loadDetails.date).format("ll") }}</p>
                                </div>
                                <div class="pt-3 mt-3 px-3 bg-white table-custom-border rounded w-100 text-left h-300px">
                                    <h6 class="font-weight-bold">{{ $t('loadDetails.progress') }}</h6>
                                    <hr class="my-0" />
                                    <div class="mb-3">
                                        <div v-for="(step, index) in steps" :key="index"
                                            class="d-flex items-center justify-content-between mt-3">
                                            <p class="f-14 text-grey my-0">{{ stepDisplay(step.label) }}</p>
                                            <b-spinner v-if="step.label === 'Step 02' && pollingInterval" variant="main"
                                                small :label="$t('loadDetails.loading')"></b-spinner>
                                            <b-img v-else :src="step.completed === 'not-open' ? require('@/assets/check-grey.svg') : step.completed === 'true'
                                                ? require('@/assets/Check.svg')
                                                : require('@/assets/check-yellow.svg')
                                                "></b-img>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="9" class="pl-0 pr-3 mt-3 mt-md-0">
                                <div class="pt-3 px-3 bg-white table-custom-border rounded w-100 text-left h-100">
                                    <h6 class="font-weight-bold mb-3">{{ $t('loadDetails.basic') }}</h6>
                                    <b-row class="align-items-center">
                                        <b-col md="6" sm="12">
                                            <div class="text-left mt-3">
                                                <label for="modal-add-record-date-datepicker" class="state">{{ $t('loadDetails.dateLabel') }}</label>
                                                <date-picker v-model="loadDetails.date" :formatter="momentFormat"
                                                    :range-separator="' - '" @clear="loadDetails.date = ''"
                                                    :placeholder="$t('loadDetails.selectDate')" class="date-picker-custom"
                                                    :teleport="'body'"></date-picker>
                                                <p v-if="errors && errors.date" class="field-error">
                                                    {{ errors.date[0] }}
                                                </p>
                                            </div>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <b-form-group :label="$t('loadDetails.referenceLabel')" class="text-left mb-0">
                                                <b-form-input v-model="loadDetails.reference_number" type="text"
                                                    :placeholder="$t('loadDetails.referencePlaceholder')" class="unit" required></b-form-input>
                                                <p v-if="errors && errors.reference_number" class="field-error">
                                                    {{ errors.reference_number[0] }}
                                                </p>
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="6" sm="12" class="mt-3">
                                            <div class="text-left select_arrow ">
                                                <label class="state">{{ $t('loadDetails.driverLabel') }}</label>
                                                <v-select class="bg_white w-100 f-12" v-model="loadDetails.driver"
                                                    :options="nameOptions" item-value="id" item-text="label"
                                                    :reduce="(option) => option.id" @search="searchAssets">
                                                    <span slot="no-options">
                                                        {{ $t('loadDetails.searchDriver') }}
                                                    </span>
                                                </v-select>
                                                <p v-if="errors && errors.driver" class="field-error">
                                                    {{ errors.driver[0] }}
                                                </p>
                                            </div>
                                        </b-col>
                                        <b-col md="12">
                                            <hr class="mt-4 mb-3" />
                                        </b-col>
                                        <b-col md="12">
                                            <div class="d-flex align-items-center justify-content-between w-100">
                                                <h6 class="font-weight-bold mb-0">{{ $t('loadDetails.step1Heading') }}</h6>
                                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                                    v-if="(steps[0].completed === 'false' || steps[1].completed === 'true') || (steps[0].completed === 'not-open' && steps[1].completed === 'not-open')"
                                                    @click="$bvModal.show('modal-add-manifest')">
                                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                                            fill="#367BF6" />
                                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1"
                                                            stroke="#367BF6" stroke-width="1.5" stroke-linecap="round" />
                                                    </svg>
                                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('loadDetails.manifest') }}</p>
                                                </div>
                                            </div>
                                            <div class="d-flex items-center gap-3 mt-5 flex-wrap"
                                                :class="manifestFiles.length ? 'mb-5' : ''">
                                                <div class="position-relative cursor-pointer"
                                                    v-for="(file, index) in manifestFiles" @click="setMedia(file)"
                                                    :key="index">
                                                    <div
                                                        class="manifest-file-icon d-flex align-items-center justify-content-center">
                                                        <i v-if="file.file && file.file.includes('.pdf')"
                                                            class="fa fa-file-pdf-o text-danger-color f-40"></i>
                                                        <i v-else class="fa fa-file-image-o text-main f-40"></i>
                                                    </div>
                                                    <i class="fa fa-trash text-danger-color f-20 delete-manifest-file"
                                                        @click.stop="setFileData(file.id)"></i>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col md="12">
                                            <hr class="my-3" />
                                        </b-col>
                                        <b-col md="12" class="mb-5">
                                            <div class="d-flex align-items-center justify-content-between w-100 mb-4">
                                                <h6 class="font-weight-bold mb-0">{{ $t('loadDetails.step2Heading') }}</h6>
                                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                                    @click="$bvModal.show('modal-load-results')"
                                                    v-if="steps[0].completed === 'true' && steps[1].completed === 'true'">
                                                    <p class="text_primary mb-0 fw-600">{{ $t('loadDetails.viewResults') }}</p>
                                                </div>

                                            </div>
                                            <h6 class="font-weight-bold" v-for="(result, index) in resultData" :key="index">
                                                {{ result }}</h6>
                                        </b-col>
                                        <b-col md="12" class="mb-3">
                                            <div class="d-flex align-items-center w-100 flex-wrap gap-3"
                                                :class="(loadDetails.status === 'Open' && (steps[0].completed === 'true' && steps[1].completed === 'true')) ? 'justify-content-between' : 'justify-content-end'">
                                                <div class="d-flex align-items-center"
                                                    v-if="(loadDetails.status === 'Open' && (steps[0].completed === 'true' && steps[1].completed === 'true'))">
                                                    <b-button class="border-0 assigned-equipment w-100px mr-3"
                                                        variant="success"
                                                        @click="setLoadDetailsStatus('Accepted')">{{ $t('loadDetails.accept') }}</b-button>

                                                    <b-button type="button" class="w-125px h-40px" variant="danger"
                                                        @click="setLoadDetailsStatus('Rejected')">
                                                        {{ $t('loadDetails.reject') }}
                                                    </b-button>

                                                </div>
                                                <div class="d-flex align-items-center justify-content-end">
                                                    <b-button :class="hasChanged ? 'mr-3' : ''" class="mx-0 h-40px w-100px"
                                                        variant="secondary"
                                                        @click="$router.push({ name: 'HazmatCheck' })">{{ $t('loadDetails.close') }}</b-button>
                                                    <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary"
                                                        v-if="hasChanged" @click="updateLoadDetails">
                                                        {{ $t('loadDetails.save') }}
                                                    </b-button>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
        </b-row>
        <AddManifest :loadId="$route.params.id" @getManifestFiles="getUpdatedManifestFilesProgress" />
        <DeleteModal v-if="showActionFilePopup" @confirm="deleteManifestItem($event)" />
        <DeleteModal v-if="showHazmatFilePopup" @confirm="deleteHazmatItem($event)" />
        <LoadResults :results="loadDetails.result_data" v-if="loadDetails" />
        <PreviewHazmatFile :media="media" v-if="media" @closePreview="media = null" />
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import AddManifest from "@/components/HazmatCheck/AddManifest.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import LoadResults from "@/components/HazmatCheck/LoadResults.vue";
import { checkValueExists } from "../../../services/helper";
import PreviewHazmatFile from "@/components/HazmatCheck/PreviewHazmat.vue";
export default {
    name: "LoadDetails",
    components: {
        DatePicker,
        vSelect,
        AddManifest,
        DeleteModal,
        LoadResults,
        PreviewHazmatFile
    },
    data() {
        return {
            moment,
            checkValueExists,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            loadDetails: null,
            defaultData: null,
            showActionFilePopup: false,
            showHazmatFilePopup: false,
            media: null,
            errors: {},
            fileId: null,
            manifestFiles: [],
            processingStatus: null,
            resultData: [],
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            nameOptions: [],
            pollingInterval: null,
            steps: [
                { label: "Step 01", completed: "false" },
                { label: "Step 02", completed: "false" },
            ]
        }
    },
    computed: {
        ...mapGetters(["userCompany"]),
        statusOptions() {
            return [
                { value: 'New', text: this.$t('hazmatCheckPage.statusNew') },
                { value: 'Open', text: this.$t('hazmatCheckPage.statusOpen') },
                { value: 'Accepted', text: this.$t('hazmatCheckPage.statusAccepted') },
                { value: 'Rejected', text: this.$t('hazmatCheckPage.statusRejected') },
                { value: 'Fixed', text: this.$t('hazmatCheckPage.statusFixed') },
            ];
        },
        hasChanged() {
            return Object.keys(this.loadDetails).filter(field => {
                if (field !== 'manifests' && field !== 'result_data' && field !== 'driver_name') {
                    if (field === 'date') {
                        const loadDate = this.loadDetails.date ? moment(this.loadDetails.date).format('YYYY-MM-DD') : null;
                        const defaultDate = this.defaultData.date ? moment(this.defaultData.date).format('YYYY-MM-DD') : null;
                        return loadDate !== defaultDate;
                    }
                    if (field === 'driver') {
                        return this.loadDetails.driver != this.defaultData.driver;
                    }
                    return this.checkValueExists(this.loadDetails[field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        }
    },
    methods: {
        ...mapActions(["getHazmatLoadDetails", "setLoader", "getFilteredDrivers", "getHazmatLoadProcessingStatus", "getHazmatManifestFiles", "deleteManifestFile", "setNotification", "deleteHazmatLoad", "updateHazmatLoadDetails"]),
        stepDisplay(label) {
            if (label === 'Step 01') return this.$t('loadDetails.step01');
            if (label === 'Step 02') return this.$t('loadDetails.step02');
            return label;
        },
        setLoadDetailsStatus(status) {
            this.loadDetails.status = status;
            this.updateLoadDetails();
        },
        setMedia(media) {
            this.media = media.file;
            this.$nextTick(() => {
                this.$bvModal.show('modal-manifest-preview');
            });
        },
        setFileData(id) {
            this.showActionFilePopup = true
            this.fileId = id
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async updateLoadDetails(showNotification = true) {
            try {
                const nullKeys = this.checkNullValues({
                    date: this.loadDetails.date,
                    driver: this.loadDetails.driver,
                    reference_number: this.loadDetails.reference_number
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.updateHazmatLoadDetails({
                        loadId: this.$route.params.id,
                        payload: { ...this.loadDetails, date: moment(this.loadDetails.date).format('YYYY-MM-DD') }
                    })
                    if (showNotification) {
                        await this.setNotification({
                            msg: this.$t('loadDetails.updated'),
                            type: "success",
                            color: "green",
                        });
                    }
                    await this.fetchLoadDetails()
                    this.setLoader(false)
                } else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('loadDetails.fieldRequired')];
                    });
                    throw error;
                }

            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false)
            }
        },
        async deleteHazmatItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteHazmatLoad(`${this.$route.params.id}/?company_id=${this.userCompany}`
                    )
                    await this.setNotification({
                        msg: this.$t('loadDetails.deleted'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$router.push({ name: "HazmatCheck" })
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.showHazmatFilePopup = false
                this.setLoader(false)
            }
        },
        async deleteManifestItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteManifestFile({
                        loadId: this.$route.params.id,
                        documentID: `${this.fileId}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('loadDetails.manifestDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.fileId = null
                    this.showActionFilePopup = false
                    await this.fetchLoadDetails()
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.showActionFilePopup = false
                this.setLoader(false)
            }
        },
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                if (driverRecords.length) {
                    driverRecords.map((item) => {
                        options.push({
                            id: item.id,
                            label: item.name
                        });
                    });
                }
                this.nameOptions = [...new Map(options.map(item => [item['id'], item])).values()]
            }

        },
        updateStepsCompletion(processingStatus) {
            this.steps.forEach(step => step.completed = 'false');
            const statusText = processingStatus.toLowerCase();
            if (statusText.includes('step 01 completed') || statusText.includes('step 1 completed')) {
                this.steps[0].completed = "true";
            }
            else if (statusText.includes('step 02 completed') || statusText.includes('step 2 completed')) {
                this.steps[0].completed = "true";
                this.steps[1].completed = "true";
                if (this.pollingInterval) {
                    clearInterval(this.pollingInterval);
                    this.pollingInterval = null;
                }
            }
            else if (statusText.includes('retrying ocr (attempt 1/2)')) {
                this.steps[0].completed = "true";
                this.steps[1].completed = "false";
            }
            else if (statusText.includes('error - llm analysis failed')) {
                this.steps[0].completed = "false";
                this.steps[1].completed = "false";
            }
            else {
                this.steps[0].completed = "not-open";
                this.steps[1].completed = "not-open";
            }
            // if (statusText.includes('step 03 completed') || statusText.includes('step 3 completed')) {
            //     this.steps[0].completed = true;
            //     this.steps[1].completed = true;
            //     this.steps[2].completed = true;
            // }
            // if (statusText.includes('step 04 completed') || statusText.includes('step 4 completed')) {
            //     this.steps[0].completed = true;
            //     this.steps[1].completed = true;
            //     this.steps[2].completed = true;
            //     this.steps[3].completed = true;
            // }
        },
        async getUpdatedManifestFilesProgress() {
            try {
                this.setLoader(true);
                this.loadDetails.status = 'Open';
                await this.updateLoadDetails(false)
                await this.fetchLoadDetails(true);
                this.setLoader(false);
            }
            catch (error) {
                this.setLoader(false);
                console.error(error);
            }
        },
        async getManifestFiles(manifests, addPolling = false) {
            try {
                this.manifestFiles = manifests;
                if (addPolling) {
                    this.pollingInterval = setInterval(async () => {
                        const statusResponse = await this.getHazmatLoadProcessingStatus(this.$route.params.id);
                        if (statusResponse) {
                            this.processingStatus = statusResponse.processing_status;
                            this.resultData = statusResponse.result_data || [];
                            this.updateStepsCompletion(statusResponse.processing_status);
                        }
                    }, 5000);
                } else {
                    const statusResponse = await this.getHazmatLoadProcessingStatus(this.$route.params.id);
                    if (statusResponse) {
                        this.processingStatus = statusResponse.processing_status;
                        this.resultData = statusResponse.result_data || [];
                        this.updateStepsCompletion(statusResponse.processing_status);
                    }
                }
                const statusResponse = await this.getHazmatLoadProcessingStatus(this.$route.params.id);
                if (statusResponse) {
                    this.processingStatus = statusResponse.processing_status;
                    this.resultData = statusResponse.result_data || [];
                    this.updateStepsCompletion(statusResponse.processing_status);
                }

            }
            catch (error) {
                console.error(error);
            }
        },
        async fetchLoadDetails(addPolling = false) {
            try {
                this.setLoader(true);
                const data = await this.getHazmatLoadDetails(this.$route.params.id);
                await this.getManifestFiles(data.manifests, addPolling);
                this.loadDetails = data;
                this.defaultData = JSON.parse(JSON.stringify(this.loadDetails))
                if (this.loadDetails.date) {
                    this.loadDetails.date = moment.tz(this.loadDetails.date, this.userTimeZone).toDate();
                }
                if (this.loadDetails.driver) {
                    this.nameOptions.push({
                        id: this.loadDetails.driver,
                        label: this.loadDetails.driver_name
                    })
                }
                this.setLoader(false);
            } catch (error) {
                console.error(error);
                this.setLoader(false);
            }
        }
    },
    mounted() {
        this.fetchLoadDetails();
    },
    beforeDestroy() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    },
}
</script>
<style scoped>
.delete-manifest-file {
    position: absolute;
    right: 2px;
    top: 2px;
    z-index: 1;
    cursor: pointer;
    color: black;
}

.h-300px {
    height: 300px;
}

.manifest-file-icon {
    height: 80px;
    width: 80px;
    background: #F5F5F5;
    border-radius: 8px;
}</style>